import { render, staticRenderFns } from "./ForgeViewerWidget.vue?vue&type=template&id=f928eb8c&scoped=true&"
import script from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"
export * from "./ForgeViewerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f928eb8c",
  null
  
)

export default component.exports